// Brain-approved marketing testimonials for the auth pages (source: the FundTap
// brain testimonials.md — Tier Hero/A/B, named). Quotes are verbatim.
//
// Quotes are stored as ordered segments so the card can give a few key phrases
// full-white emphasis while the rest recedes (the editorial highlight look).
// The concatenation of every `t` is the exact verbatim quote — emphasis only,
// no re-wording. The card is quote-first: it renders parts + name + company only.
export const AUTH_TESTIMONIALS = {
  mjwebs: {
    parts: [
      { t: "I honestly " },
      { t: "wish I used FundTap years ago", em: true },
      {
        t: ". This is precisely the style of financing my business needed to assist with cash flow with "
      },
      { t: "minimal risk", em: true },
      { t: " compared to conventional business lending." }
    ],
    name: "Mitchell Musarra",
    company: "MJWebs"
  },
  yum: {
    parts: [
      { t: "We love the " },
      { t: "convenience and accessibility", em: true },
      { t: " of FundTap. It's " },
      { t: "simple", em: true },
      {
        t: " which is really nice and has enabled us to do things we wouldn't otherwise have been able to do."
      }
    ],
    name: "Sarah Hedger",
    company: "Co-Founder, YUM Granola"
  }
};
